
import { Navigate, Outlet } from 'react-router-dom';

import { isLogin } from '../utils';
import { useEffect } from 'react';
import { getCookie } from '../utils/commonFunctions';
import axios from 'axios';
import Cookies from 'js-cookie';

const PrivateRoutes = () => {
  const auth = isLogin();

  useEffect(() => {
    const role_id = getCookie("user_type");
    if (role_id) {
      const fetchMenuListApi = async () => {
        try {
          const response = await axios.get(`/api/admin/module-mappings/?role_id=${role_id}`);
          if (response.status === 200) {
            const itemsArray = response.data.results;
            Cookies.set('modulepermissions', JSON.stringify(itemsArray));
          }
        } catch (error) {
          console.error(error);
        }
      };
      fetchMenuListApi();
    }
  }, []);

  return auth ? <Outlet /> : <Navigate to='/login' />;
};

export default PrivateRoutes;
